export const config = {
  title: "Heritage Masonry & Construction Corp",
  meta: {
    description:
      "Heritage Masonry & Construction Corp provides expert masonry, concrete, and general construction services in Barrie, Ontario, and surrounding areas.",
    keywords: [
      "Masonry Barrie ON",
      "Construction Barrie",
      "Concrete Services Ontario",
      "General Contractor Barrie",
      "Heritage Masonry and Construction",
      "Bricklaying Stonework Canada",
    ],
    author: "Heritage Masonry & Construction Corp",
    canonicalUrl: "https://hmccorpon.com/",
  },
  sections: {
    header: {
      businessName: "Heritage Masonry & Construction Corp",
    },
    sectionB: {
      heroTitle: "Built on Craftsmanship, Grounded in Heritage",
      heroSubtitle:
        "Serving Barrie and Beyond with Expert Construction Services",
      learnAboutText: "Learn More",
      phoneNumber: "6475813510",
      phoneLabel: "(647) 581-3510",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1349030917/photo/business-and-finance-looking-up-at-high-rise-office-buildings-in-the-financial-district-of-a.jpg?s=612x612&w=0&k=20&c=NSnN0va-f1OBG_GA7bTVmUIoBwNDKUXtHD8_PzeTNiA=",
      cardData: [
        {
          title: "Masonry & Bricklaying",
          description:
            "Specialized stone, brick, and block masonry for new builds and restorations.",
        },
        {
          title: "Concrete Work",
          description:
            "Driveways, foundations, patios, and walkways done with precision and durability.",
        },
        {
          title: "General Construction",
          description:
            "Complete residential and commercial construction solutions tailored to your needs.",
        },
      ],
      description:
        "Heritage Masonry & Construction Corp brings years of experience, heritage techniques, and modern execution to every construction project across Barrie and Ontario.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We specialize in a broad range of masonry, concrete, and general construction solutions.",
      cards: [
        {
          title: "Concrete Flatwork",
          description:
            "Driveways, patios, and structural slabs poured to perfection.",
          imageSrc:
            "https://media.istockphoto.com/id/154963159/photo/cement-worker-working-on-foundation.jpg?s=612x612&w=0&k=20&c=q2AznGfJ56Dq5QornE8zd-lQzRUKMDhpCVs4hdH6Nqw=",
          imageAlt: "Concrete Work",
        },
        {
          title: "Restoration & Waterproofing",
          description:
            "Restore historical brickwork and protect structures from moisture damage.",
          imageSrc:
            "https://media.istockphoto.com/id/2160402560/photo/construction-worker-is-inspecting-roof-tile-cracked.jpg?s=612x612&w=0&k=20&c=xlJhNN05zKhnGXrZRYiStTPKwri2vdvY7YtSIgUanXw=",
          imageAlt: "Restoration Services",
        },
        {
          title: "Bricklaying & Blockwork",
          description:
            "Custom brick and block structures with exceptional finish.",
          imageSrc:
            "https://media.istockphoto.com/id/1024238262/photo/bricklayer-making-a-wall.jpg?s=612x612&w=0&k=20&c=bYbGy-uKuJj5XMFELBeYZJth9hCQe9gwxEhNovq4JFc=",
          imageAlt: "Bricklaying",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Stone Veneer Installation",
        "Tuckpointing",
        "Retaining Walls",
        "Chimney Repairs",
        "Parging",
        "Excavation",
        "Foundation Repairs",
        "Waterproofing Systems",
        "Deck & Fence Installation",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://media.istockphoto.com/id/1362666475/photo/female-contractors-working-at-construction-site.jpg?s=612x612&w=0&k=20&c=qJv6Y4cqq-A9BrghBpg8YTVn8KM-eK9yWa_0VAdAAnM=",
        alt: "Heritage Masonry & Construction Team",
      },
      aboutText: [
        "Heritage Masonry & Construction Corp is a family-operated business rooted in old-world craftsmanship and built for modern projects.",
        "We take pride in our attention to detail, integrity in service, and high-quality workmanship for both residential and commercial clients.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Heritage Masonry & Construction Logo",
      businessName: "Heritage Masonry & Construction Corp",
      contact: {
        phone: "6475813510",
        phoneLabel: "(647) 581-3510",
        email: "heritagemasonryandconstruction@gmail.com",
        website: "https://hmccorpon.com/",
        address: "195 Dunlop St W, Barrie, ON L4N 1B4, Canada",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "195 Dunlop St W, Barrie, ON L4N 1B4, Canada",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2873.0384982856544!2d-79.6950589!3d44.3897158!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882aa33bc93c573f%3A0xc88846ddcd3a63a6!2s195%20Dunlop%20St%20W%2C%20Barrie%2C%20ON%20L4N%201B4%2C%20Canada!5e0!3m2!1sen!2sca!4v1717500000000",
    },
  },
};

export default config;
